// src/layouts/MobileLayout.js
import React, { createContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../components/Footer';
import MobileCustomerFlowHeaderStepper from '../components/CustomerFlow/MobileCustomerFlowHeaderStepper';
import './MobileLayout.css';

const logoSmall = process.env.REACT_APP_CLIENT_LOGO || '/assets/images/cirenio.svg';

// Contexto para el título de la página
export const PageTitleContext = createContext();

/** Setter lives on routes under MobileLayout (e.g. customer flow). */
export const MobileHeaderStepperContext = createContext({
  mobileHeaderStepperUi: null,
  setMobileHeaderStepperUi: () => {},
});

const MobileLayout = () => {
  const [pageTitle, setPageTitle] = useState('Tu compra');
  const [mobileHeaderStepperUi, setMobileHeaderStepperUi] = useState(null);

  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
      <MobileHeaderStepperContext.Provider
        value={{ mobileHeaderStepperUi, setMobileHeaderStepperUi }}
      >
        <div className="layout-horizontal">
          <div className="header-top mobile-layout-header-top d-flex align-items-center justify-content-between gap-2">
            <div className="d-flex align-items-center min-width-0 flex-grow-1">
              <img
                src={logoSmall}
                alt="Logo"
                style={{ height: '30px', marginRight: '12px', flexShrink: 0 }}
              />
              <h4 className="mb-0 text-truncate">{pageTitle}</h4>
            </div>
            {mobileHeaderStepperUi ? (
              <MobileCustomerFlowHeaderStepper
                flowStepNames={mobileHeaderStepperUi.flowStepNames}
                stepStatuses={mobileHeaderStepperUi.stepStatuses}
                currentStepIndex={mobileHeaderStepperUi.currentStepIndex}
              />
            ) : null}
          </div>

          <div className="mobile-container">
            <Outlet />
          </div>
          <Footer />
        </div>
      </MobileHeaderStepperContext.Provider>
    </PageTitleContext.Provider>
  );
};

export default MobileLayout; 